interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'sidebar';
}

const sizeMap = {
  sm: 'w-6 h-6',
  md: 'w-20',
  lg: 'w-11',
  xl: 'w-40',
  sidebar: 'w-full h-12',
};

export function Logo({ className = '', size = 'md' }: LogoProps) {
  return (
    <img
      src="/images/logo.svg"
      alt="Logo"
      className={`object-contain ${sizeMap[size]} ${className}`}
    />
  );
}
